import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';

import { apolloErrorLink, apolloOperationNameLink, apolloRequestIdLink } from './links';

/**
 * HTTP only: the app has no subscription yet. Auth is the API's HttpOnly
 * session cookie on the workspace's parent domain, sent with
 * `credentials: 'include'` — no token handling here.
 */
const httpLink = createHttpLink({
  uri: import.meta.env.VITE_OMB_API_GQL_URL,
  credentials: 'include',
});

export const apolloClient = new ApolloClient({
  link: apolloErrorLink
    .concat(apolloRequestIdLink)
    .concat(apolloOperationNameLink)
    .concat(httpLink),
  cache: new InMemoryCache(),
});
